import React, { useEffect, useState } from "react";
import CustomDialog from "../../components/common/CustomDialog";
import { CiSettings } from "react-icons/ci";
import userImg from "../../assets/userImg.png";
import Text from "../../components/typography/Text";
import { FiEdit3 } from "react-icons/fi";
import CustomSwitch from "../../components/common/CustomSwitch";
import CustomTab from "../../components/common/CustomTab";
import AdvisorProfileTab from "./AdvisorProfileTab";
import AdvisorlogTab from "./AdvisorlogTab";
import { changeAdvisorStatusFn } from "../../Services/advisorService";

const AdvisorProfile = ({ open, setOpen, data,status,setStatus }) => {
  const [advisorStatus, setAdvisorStatus] = useState(data?.advisor_status);

  useEffect(() => {
    setAdvisorStatus(data?.advisor_status);
  }, [data]);

  return (
    <CustomDialog
      open={open}
      setOpen={setOpen}
      noTitleWrapper={true}
      className="mt-0"
      width={"70vw"}
      height={"auto"}
    >
      <div className="mt-0 mb-2 flex p-2 justify-between items-center bg-[#0051AD]">
        <div className="flex gap-2 items-center">
          <CiSettings />
          <p className="text-white font-semibold">Advisor Profile</p>
        </div>
        <div>
          <p
            className="text-white underline cursor-pointer"
            onClick={() => setOpen(false)}
          >
            close
          </p>
        </div>
      </div>

      <div className="flex flex-col p-4 mb-2 bg-white border border-gray-200 rounded-md mt-4">
        <div className="flex justify-between items-center">
          <div className="flex items-center">
            <img
              src={userImg}
              alt="Advisor"
              className="w-12 h-12 rounded-full object-scale-down bg-[#8080801c]"
            />
            <div>
              <Text className="!font-bold ml-2">{data?.name}</Text>
              <Text className="!font-bold ml-2">#{data?.advisor_display_id}</Text>
            </div>
            {/* <FiEdit3 /> */}
          </div>

          <div className="flex items-center">
            <CustomSwitch
              name="active"
              value={advisorStatus === "Active"}
              onChange={async (val) => {
                const newStatus = val ? "Active" : "Inactive";
                try {
                  await changeAdvisorStatusFn({
                    advisor_id: data?.advisor_id,
                    advisor_status: newStatus,
                  });
                  setAdvisorStatus(newStatus); // update local state
                  setStatus(prev => !prev);
                } catch (err) {
                  console.error("Failed to update advisor status:", err);
                }
              }}
            />
            <span className="ml-2 font-semibold">Active</span>
          </div>
        </div>

        <div className="flex justify-between items-center mt-2">
          <div className="w-1/3">
            <span className="text-sm font-medium text-gray-400">
              Joined As:
            </span>{" "}
            <span className="text-sm font-semibold ml-1">{data?.join_as}</span>
          </div>
          <div className="w-1/3">
            <span className="text-sm font-medium text-gray-400">
              Mobile No:
            </span>{" "}
            <span className="text-sm font-semibold ml-1">
              {data?.mobile_number}
            </span>
          </div>
          <div className="w-1/3">
            <span className="text-sm font-medium text-gray-400">Email:</span>{" "}
            <span className="text-sm font-semibold ml-1">{data?.email}</span>
          </div>
        </div>
      </div>

      <CustomTab
        tabList={[
          {
            title: "Profile",
            startIcon: null,
            endIcon: null,
            component: <AdvisorProfileTab data={data} />,
          },
          {
            title: "Logs",
            startIcon: null,
            endIcon: null,
            component: <AdvisorlogTab />,
          },
        ]}
        tabIndex={0}
      />
    </CustomDialog>
  );
};

export default AdvisorProfile;
